/**
 * 解析 word_en / word_components / word_defs 等管道分隔字段（与 word_en 槽位一一对应）
 * 现全量使用 | 分隔
 * @param {string|string[]|null|undefined} val
 * @returns {string[]}
 */
export function splitPipeField (val) {
  if (val === null || val === undefined) return []
  if (Array.isArray(val)) {
    return val.map((s) => String(s || '').trim()).filter(Boolean)
  }
  return String(val)
    .split('|')
    .map((s) => s.trim())
    .filter(Boolean)
}
